<template>
  <div class="wrapper">
    <div class="logo">
      <img @click="onBlockscan" id="logo" src="~@/assets/logo.gif" alt="PLA" />
    </div>
    <div class="login-form-container">
      <p class="page-form-title">Welcome back</p>
      <p class="page-form-tip">Login to your account.</p>
      <el-form
        class="login-form"
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item label="Username:" prop="username">
          <el-input
            name="username"
            v-model="form.username"
            :disabled="isLoading"
            placeholder="Please enter the username."
          ></el-input>
        </el-form-item>

        <el-form-item label="Private key:" prop="privateKey">
          <el-input
            name="privateKey"
            v-model="form.privateKey"
            :disabled="isLoading"
            placeholder="Please enter the private key."
          />
        </el-form-item>
        <el-form-item>
          <p class="is-tips">
            Don't have an account? Click to
            <router-link to="/register">sign up</router-link>.
          </p>
          <p class="is-tips">
            Or visit the
            <router-link to="/dashboard/block-scan-page"
              >Block Scan</router-link
            >
            directly.
          </p>
        </el-form-item>
        <el-form-item class="login-button-container">
          <el-button
            class="login-button fullwidth"
            type="primary"
            @click="onSubmit"
            :loading="isLoading"
          >
            LOGIN
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import cachedInfo from '../util/global'

export default {
  name: 'login',

  data() {
    return {
      isLoading: false,
      form: {
        username: '',
        privateKey: ''
      },
      rules: {
        username: [
          {
            required: true,
            message: 'Please enter username.',
            trigger: 'change'
          },
          {
            pattern: /^[a-z_0-9]{1,32}$/,
            message: 'Username has to be from 5 to 30 characters in length.',
            trigger: 'change'
          }
        ],
        privateKey: [
          {
            required: true,
            message: 'Please enter private key.',
            trigger: 'change'
          },
          {
            pattern: /^[A-Za-z0-9]{64}$/,
            message: 'Private key has to be 64 characters in length.',
            trigger: 'change'
          }
        ]
      },
      cachedInfo
    }
  },

  methods: {
    ...mapActions(['login']),
    onBlockscan() {
      this.$router.push({ name: 'block-scan-page' })
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid) return false

        this.isLoading = true

        this.login({
          username: `${this.form.username}@${this.cachedInfo.userNode}`,
          privateKey: this.form.privateKey
        })
          .then((account) => {
            this.isLoading = false
            this.$router.push({ name: 'block-scan-page' })
          })
          .catch((err) => {
            this.checkUser(err)
          })
      })
    },
    checkUser(errorMessage) {
      this.$axios({
        method: 'get',
        url: `/api/users/${this.form.username}@${this.cachedInfo.userNode}`
      })
        .then((response) => {
          this.isLoading = false

          if (response.data && response.data.status === 'pending') {
            this.$message({
              showClose: true,
              message: `Login failed. Your account is under review, please wait for the review to pass, and log in again later.`,
              type: 'error',
              duration: 5000
            })
          } else if (response.data && response.data.status === 'rejected') {
            this.$message({
              showClose: true,
              message: `Login failed. Your account review failed, please contact the administrator.`,
              type: 'error',
              duration: 5000
            })
          } else {
            if (
              errorMessage.message.includes(
                'must have at least one of the permissions'
              )
            ) {
              this.$message({
                showClose: true,
                message:
                  'Login failed. Your account is disabled, please contact the administrator.',
                type: 'error',
                duration: 5000
              })
              return
            }

            if (
              errorMessage.message.includes(
                'query signatories did not pass validation'
              )
            ) {
              this.$message({
                showClose: true,
                message:
                  'Login failed. Your username or private key is wrong, please confirm and re-enter.',
                type: 'error',
                duration: 5000
              })
              return
            }

            this.$message({
              showClose: true,
              message: errorMessage,
              type: 'error'
            })
          }
        })
        .catch((error) => {
          this.isLoading = false

          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss">
.wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-self: center;
  min-height: 100vh;
}
.login-form-container {
  margin: auto;
}
.logo {
  display: flex;
  justify-content: center;
  background: #333;
}
.logo img {
  display: block;
  margin: 0 auto;
  height: 4rem;
  margin: 1rem;
  border-radius: 8px;
  cursor: pointer;
}
.login-form {
  width: 25rem;
  justify-content: center;
}
.is-tips {
  color: #999;
  margin-bottom: -15px;
  a {
    text-decoration: underline;
  }
}
</style>
